import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { FeatureFlagService } from '../portal/shared/services/feature-flag.service';
import { StorageService } from '../account/services/storage.service';

export const maintenanceGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const featureFlags = inject(FeatureFlagService);
  const router = inject(Router);
  const storageService = inject(StorageService);

  if (featureFlags.isEnabled('EXT_UNDER_MAINTENANCE')) {
    // Remembered so the "Refresh page" button on the maintenance page can send
    // the user back to what they were trying to reach, once maintenance ends.
    storageService.saveRedirectUrl(state.url);
    return router.parseUrl('/maintenance');
  }

  return true;
};
